export default "__VITE_ASSET__Cm2NYqUF__"